import axios from "axios";
import { Constants } from "../utils/Constants";

export const getDashboard = () => {
    return axios.get(`${Constants.baseUrl}/dashboard`);
}
